import { useState } from 'react'

/**
 * Presentation guidee (S62) — « qu'ils n'aient pas a reflechir ».
 *
 * Un producteur devant une zone de texte vide n'ecrit rien. Devant trois
 * questions courtes, avec un exemple en gris dans chaque champ, il repond.
 * Le portail assemble les trois reponses en UN paragraphe, montre le resultat
 * en direct, et c'est ce paragraphe qui est enregistre (champ `description`
 * inchange cote API : aucune migration).
 *
 * Quand une presentation existe deja, on la montre telle quelle dans une zone
 * de texte : on ne decoupe jamais un texte que le producteur a ecrit lui-meme.
 * Un bouton permet de repartir des trois questions.
 */
const QUESTIONS = [
  { k: 'qui', l: 'Qui êtes-vous ?', ex: 'Ex. : Nous sommes une petite ferme familiale au Morne-Vert, depuis trois générations.' },
  { k: 'quoi', l: 'Que cultivez-vous ou fabriquez-vous ?', ex: 'Ex. : Des fruits de saison, des légumes racines et du miel de nos ruches.' },
  { k: 'fier', l: 'Ce qui vous rend fier', ex: 'Ex. : Tout est cultivé sans produit chimique, cueilli la veille du marché.' },
]

const assembler = (r) => QUESTIONS.map((q) => (r[q.k] || '').trim()).filter(Boolean).join(' ')

const champ = 'w-full text-[15px] leading-relaxed px-3.5 py-3 rounded-[13px] text-ink resize-none'
const bord = { border: '1px solid rgb(var(--c-green) / 0.15)', background: 'rgba(255,255,255,0.75)' }

export default function PresentationGuidee({ value, onChange }) {
  // Mode guide si la presentation est vide au montage (ou sur demande)
  const [guide, setGuide] = useState(() => !(value || '').trim())
  const [reponses, setReponses] = useState({ qui: '', quoi: '', fier: '' })

  const repondre = (k, v) => {
    const suivant = { ...reponses, [k]: v }
    setReponses(suivant)
    onChange(assembler(suivant))
  }

  if (!guide) {
    return (
      <div className="glass-surface rounded-[20px] p-4">
        <div className="flex items-center justify-between mb-1.5">
          <p className="text-[11px] font-bold text-ink/50">Présentation (vue par le client)</p>
          <button type="button" onClick={() => { setGuide(true); setReponses({ qui: '', quoi: '', fier: '' }); onChange('') }}
            className="text-[11px] font-bold" style={{ color: 'rgb(var(--c-primary))' }}>
            Repartir des 3 questions
          </button>
        </div>
        <textarea value={value} rows={5} onChange={(e) => onChange(e.target.value)} className={champ + ' resize-y'} style={bord} />
      </div>
    )
  }

  const apercu = assembler(reponses)
  return (
    <div className="glass-surface rounded-[20px] p-4">
      <p className="text-[11px] font-bold text-ink/50">Présentation (vue par le client)</p>
      <p className="text-[12.5px] text-ink/65 mt-0.5 mb-3 leading-snug">
        Trois questions, une phrase chacune : on assemble le texte pour vous.
      </p>
      <div className="flex flex-col gap-3">
        {QUESTIONS.map((q, i) => (
          <label key={q.k} className="block">
            <span className="flex items-center gap-2 text-[13px] font-bold text-ink mb-1.5">
              <span className="w-5 h-5 rounded-full flex items-center justify-center text-[11px] text-green" style={{ background: 'rgb(var(--c-primary))' }}>{i + 1}</span>
              {q.l}
            </span>
            <textarea value={reponses[q.k]} rows={2} placeholder={q.ex}
              onChange={(e) => repondre(q.k, e.target.value)} className={champ} style={bord} />
          </label>
        ))}
      </div>
      {apercu && (
        <div className="mt-3.5 rounded-2xl px-4 py-3" style={{ background: 'rgba(20,184,166,0.08)', border: '1px solid rgba(20,184,166,0.25)' }}>
          <p className="text-[10px] font-bold uppercase tracking-[0.16em] mb-1" style={{ color: 'rgb(var(--c-teal))' }}>Ce que le client lira</p>
          <p className="text-[13.5px] leading-relaxed text-ink/85">{apercu}</p>
        </div>
      )}
      <button type="button" onClick={() => setGuide(false)} className="mt-3 text-[11px] font-bold text-ink/55">
        Je préfère écrire mon texte librement
      </button>
    </div>
  )
}
